var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.draggedElement && _vm.dragPosition)?_c('div',{staticClass:"breakdance-drag-ghost-element",style:({
    top: _vm.dragPosition?.y ? _vm.dragPosition.y + 'px' : '0',
    left: _vm.dragPosition?.x ? _vm.dragPosition.x + 'px' : '0'
  })},[_vm._v(" "+_vm._s(_vm.elementName)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }